import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { lockScroll, unlockScroll } from './top-utils.js';
import {
  checkFirstVisit,
  showMainContentDirectly,
  initBackgroundLottie,
  initLogoLoading,
  initLottieAnimation
} from './top-loading.js';
import {
  initBgFadeIn,
  initBackgroundFadeOut,
  initTextAnimation
} from './top-hero.js';
import { addLightDots } from './top-lights.js';
import { imageSwitcher } from './top-business-field.js';
import { initTopRecruitAnimation } from './top-recruit.js';
import { initCatchCopyFollowAnimation } from './top-catch-copy.js';

/* ====================================
# トップページアニメーション メイン関数
==================================== */
export const animationTop = () => {
  // 初期化実行
  if (checkFirstVisit()) {
    // 初回訪問時のみアニメーション実行
    lockScroll(); // スクロールをロック
    initLogoLoading(() => initLottieAnimation());
    // initTextAnimation() は showMainContent() 内で実行される
  } else {
    // 2回目以降の訪問
    showMainContentDirectly();
  }

  // キャッチコピー追従アニメーション
  initCatchCopyFollowAnimation();

  // 画像切り替え機能
  imageSwitcher();

  // 採用セクションアニメーションは、Lottieアニメーション完了後に実行される
  // （showMainContent関数とshowMainContentDirectly関数内で呼ばれる）
};